/*
  Метод find с асинхронным вызовом внутри (например, сравнение файлов на итерациях с использованием readAsArrayBuffer).
  В зависимости от параметра returnIndexOnly вернет либо индекс элемента, либо сам элемент.
  findAsync(arr, async (thing) => {
    const ret = await findThing();
    return false;
  }) 
*/
export const findAsync = async (
  arr: any[],
  asyncCallback: any,
  returnIndexOnly?: boolean
) => {
  const promises = arr.map((el) => asyncCallback(el));
  const results = await Promise.all(promises);
  const index = results.findIndex((result) => result);
  return returnIndexOnly ? index : arr[index];
};

/**
 * Получает массив успешных результатов из массива PromiseSettledResult.
 *
 * @template T - Тип результата промиса.
 * @param {PromiseSettledResult<T>[]} results - Массив результатов промисов.
 * @returns {T[]} Массив успешных результатов.
 */

export const getFulfilledResults = <T>(
  results: PromiseSettledResult<T>[]
): T[] => {
  return results
    .filter(
      (result): result is PromiseFulfilledResult<T> =>
        result.status === 'fulfilled'
    )
    .map((result) => result.value);
};
